import React from 'react'

export const toolbarTourConfig = (t) => ({
    id: 'toolbar-guide',
    name: t('tour:toolbar_guide_name'),
    description: t('tour:toolbar_guide_desc'),
    steps: [
        {
            target: '[data-tour="GRID"]',
            title: t('tour:toolbar_guide_step_0_title'),
            content: (
                <div>
                    <p>{t('tour:toolbar_guide_step_0_content')}</p>
                </div>
            ),
            placement: 'bottom'
        },
        {
            target: '[data-tour="TEXT"]',
            title: t('tour:toolbar_guide_step_1_title'),
            content: (
                <div>
                    <p>{t('tour:toolbar_guide_step_1_content')}</p>
                </div>
            ),
            placement: 'bottom'
        },
        {
            target: '[data-tour="IMAGE"]',
            title: t('tour:toolbar_guide_step_2_title'),
            content: (
                <div>
                    <p>{t('tour:toolbar_guide_step_2_content')}</p>
                </div>
            ),
            placement: 'bottom'
        },
        {
            target: '[data-tour="VIDEO"]',
            title: t('tour:toolbar_guide_step_3_title'),
            content: (
                <div>
                    <p>{t('tour:toolbar_guide_step_3_content')}</p>
                </div>
            ),
            placement: 'bottom'
        },
        {
            target: '[data-tour="AUDIO"]',
            title: t('tour:toolbar_guide_step_4_title'),
            content: (
                <div>
                    <p>{t('tour:toolbar_guide_step_4_content')}</p>
                </div>
            ),
            placement: 'bottom'
        },
        {
            target: '[data-tour="AR_IMAGE"]',
            title: t('tour:toolbar_guide_step_5_title'),
            content: (
                <div>
                    <p>{t('tour:toolbar_guide_step_5_content')}</p>
                </div>
            ),
            placement: 'bottom'
        },
        {
            target: '[data-tour="QUIZ"]',
            title: t('tour:toolbar_guide_step_6_title'),
            content: (
                <div>
                    <p>{t('tour:toolbar_guide_step_6_content')}</p>
                </div>
            ),
            placement: 'bottom'
        },
        {
            target: '[data-tour="ANNOTATION"]',
            title: t('tour:toolbar_guide_step_7_title'),
            content: (
                <div>
                    <p>{t('tour:toolbar_guide_step_7_content')}</p>
                </div>
            ),
            placement: 'bottom'
        },
        {
            target: '[data-tour="background-indicator"]',
            title: t('tour:toolbar_guide_step_8_title'),
            content: (
                <div>
                    <p>{t('tour:toolbar_guide_step_8_content')}</p>
                </div>
            ),
            placement: 'bottom'
        },
        {
            target: '[data-tour="preview-course"]',
            title: t('tour:toolbar_guide_step_9_title'),
            content: (
                <div>
                    <p>{t('tour:toolbar_guide_step_9_content')}</p>
                </div>
            ),
            placement: 'bottom'
        }
    ]
})
